import store from '@/store';
import { SparkelloWebUser } from '@/web/model/user/SparkelloWebUser';
import { UserStoreInterface } from 'sparkello-core';
import { User } from 'firebase/app';

export class UserVuexStore  implements UserStoreInterface<User> {

  public getSparkelloUser(): SparkelloWebUser {
    return store.state.userProfile;
  }

  public setSparkelloUser(userProfile: SparkelloWebUser): void {
    store.commit('setUserProfile', userProfile);
  }
}
